module.exports = __webpack_public_path__ + "media/src/application/media/r3_posted-c1a65ccb918781dd35e54b426bbc6627.png";